import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App.js';
import 'font-awesome/css/font-awesome.min.css';
import Config from './commons/config/Config.js';
import { resolveLangsUrlBase, resolveLocale } from './lang/langsUrl.js';

var TIMEOUT_CONFIG_BUSINESS_MS = 5000;

function renderApp(locale, messages) {
    ReactDOM.render(<App locale={locale} messages={messages} />, document.getElementById("root"));
}

// Pre-login: el endpoint público. Si falla o no responde a tiempo se usa la última config-business
// guardada por App.js (o ninguna → vecflow); el render no depende de esta llamada.
function fetchConfigBusiness() {
    var pedido = fetch(Config.get('apiUrlBase') + '/commons/config-business', {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
    })
    .then(function(response) {
        if (!response.ok) { throw new Error('HTTP ' + response.status); }
        return response.json();
    });
    var timeout = new Promise(function(resolve, reject) {
        setTimeout(function() { reject(new Error('timeout ' + TIMEOUT_CONFIG_BUSINESS_MS + 'ms')); }, TIMEOUT_CONFIG_BUSINESS_MS);
    });

    return Promise.race([pedido, timeout]).catch(function(error) {
        console.error('[i18n] No se pudo obtener config-business; se usa la última guardada.', error);
        try { return JSON.parse(localStorage.getItem('configBusiness')); } catch (e) { return null; }
    });
}

function bootstrapApp(configData) {
    localStorage.setItem('config', JSON.stringify(configData));
    // Valor inicial para el catch final; el definitivo depende de frontend.defaultLanguage (config-business)
    var locale = resolveLocale(null, localStorage.getItem('userLocale'), Config.get('defaultLanguage'));

    fetchConfigBusiness()
    .then(function(configBusiness) {
        locale = resolveLocale(configBusiness, localStorage.getItem('userLocale'), Config.get('defaultLanguage'));
        localStorage.setItem('userLocale', locale);
        var url = resolveLangsUrlBase(configBusiness) + '/' + locale;
        // Solo Accept: un Content-Type en un GET a otro origen dispara un preflight CORS.
        return fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } })
        .then(function(response) {
            if (!response.ok) { throw new Error('HTTP ' + response.status + ' en ' + url); }
            return response.json();
        });
    })
    .then(function(data) { renderApp(locale, data || {}); })
    .catch(function(error) {
        console.error('[i18n] No se pudo cargar el catálogo de traducciones; se usan los textos por defecto.', error);
        renderApp(locale, {});
    });
}

// Azure SSO from the mobile app authorizes with this site's Web redirect URI and marks the
// state with "app_" (see /auth/azure/redirect-app). Hand the code back to the app through its
// deep link. Runs before the auth check because /auth/azure/callback is only routed when no
// web session exists, and the app's in-app browser shares cookies/storage with the device browser.
function bounceAzureCallbackToApp() {
    var params = new URLSearchParams(window.location.search);
    var state = params.get('state') || '';
    if (window.location.pathname !== '/auth/azure/callback' || state.indexOf('app_') !== 0) {
        return false;
    }

    var target = 'vecfleet://auth/azure-callback' + window.location.search;
    window.location.replace(target);

    // Fallback when the browser asks before opening the app (e.g. iOS) or blocks the jump
    var link = document.createElement('a');
    link.href = target;
    link.textContent = 'Volver a la app VEC Fleet+';
    link.style.cssText = 'display:block;text-align:center;margin-top:40vh;font:18px sans-serif';
    document.getElementById('root').appendChild(link);
    return true;
}

if (!bounceAzureCallbackToApp()) {
    fetch('/config/config.json', {
        method: 'GET',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    })
    .then(function(response) { return response.json(); })
    .then(function(configData) { bootstrapApp(configData); })
    .catch(function() {
        try {
            var cached = JSON.parse(localStorage.getItem('config'));
            if (cached) { bootstrapApp(cached); return; }
        } catch(e) {}
        renderApp('es', {});
    });
}
